import React from 'react';
import LinkedProjects from './LinkedProjects';
import LinkedRulesets from './LinkedRulesets';
import LinkedFeatures from './LinkedFeatures';

/**
 * LinkedItems component
 * Container for displaying linked projects, features, and rulesets
 */
export default function LinkedItems({
    family,
    familyProjects,
    familyRulesets,
    familyFeatures,
    activeProjectId,
    onSelectProject,
    onSelectFeature,
    onSelectRuleset,
    onShareFamily,
    onUnshareFamily,
    onUnlinkFamily,
    onLinkToActive
}) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', flex: 1, minHeight: 0, height: '100%' }}>
            <LinkedProjects
                family={family}
                projects={familyProjects}
                activeProjectId={activeProjectId}
                onSelectProject={onSelectProject}
                onShareFamily={onShareFamily}
                onUnshareFamily={onUnshareFamily}
                onUnlinkFamily={onUnlinkFamily}
                onLinkToActive={onLinkToActive}
            />
            <LinkedFeatures features={familyFeatures} onSelectFeature={onSelectFeature} />
            <LinkedRulesets rulesets={familyRulesets} onSelectRuleset={onSelectRuleset} />
        </div>
    );
}

export { LinkedProjects, LinkedRulesets, LinkedFeatures };
